module.exports = __webpack_public_path__ + "img/web2.bf06641d.png";